export default "__VITE_ASSET__CKWJfb6B__"